import {useEffect, useState} from 'react'
import {BooksitoutServer} from '../../../../config/BooksitoutServer'
import TimeOfDayPatternResponse from '../responses/TimeOfDayPatternResponse'

const useTimeOfDayPattern = () => {
	const [data, setData] = useState<TimeOfDayPatternResponse | null>(null)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		BooksitoutServer
			.get(`/v1/statistics/time-of-day-pattern`)
			.then(res => setData(res.data))
			.finally(() => setIsLoading(false))
	}, [])

	return [data, isLoading] as const
}

export default useTimeOfDayPattern
